import { Component, OnInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap';

@Component({
  selector: 'app-ar-dashboard',
  templateUrl: './ar-dashboard.component.html',
  styleUrls: ['./ar-dashboard.component.scss']
})
export class ArDashboardComponent implements OnInit {
  activeTab;
  constructor() { }
  @ViewChild('artabset', { static: false }) artabset: TabsetComponent;
  ngOnInit() {

  }
   ngAfterViewInit() {
    if(localStorage.getItem("arActiveTab")!== null){
      this.activeTab = localStorage.getItem("arActiveTab");
      //console.log(this.activeTab);
      if(this.activeTab){
        this.goto(parseInt(this.activeTab));
      }
     }else{
      this.goto(0);
     }
   }
  goto(id) {
      if(id){
          this.artabset.tabs[id].active = true;
      }
  }
}